<template>
  <b-col md="6">
    <b-form v-if="isBrand" @submit.prevent="searchBrand()">
      <b-form-input
          id="input"
          v-model="searchedWord"
          placeholder=" جستجو"
          class="mb-1"
      ></b-form-input>
    </b-form>
    <form-group :validations="validation">
      <div slot-scope="{ errors, invalid }">
        <b-alert show class="overflow_div">
          <b-form-group>
            <label>
              {{ label }}
              <b-icon v-if="isBrand" icon="arrow-clockwise" class="d-inline" @click="refreshBrands"></b-icon>
            </label>
            <div v-for="item in radioItems">
              <input
                  type="radio"
                  :value="item.id"
                  :id="`item_${item.id}`"
                  @input="updateValue"
                  :class="{ invalid }"
                  name="item"
              />
              <label class="mr-1" :for="`item_${item.id}`">{{
                  item.name
                }}</label>
            </div>
          </b-form-group>
        </b-alert>
        <form-errors-manager :errors="errors"/>
      </div>
    </form-group>
  </b-col>
</template>
<script>
import FormGroup from "../../../validator/FormGroup.vue";
import FormErrorsManager from "../../../validator/FormErrorsManager.vue";

export default {
  name: "RadioBox",
  components: {FormGroup, FormErrorsManager},
  data() {
    return {
      searchedWord: ''
    }
  },
  props: ["validation", "radioItems", "label", "inputValue", "isBrand"],
  model: {
    prop: "inputValue",
    event: "input",
  },
  methods: {
    refreshBrands() {
      this.$store.dispatch("Brand/getBrands");
    },
    updateValue(event) {
      this.$emit("input", event.target.value);
    },
    searchBrand() {
      if (this.searchedWord != "") {
        const searchWord = {words: this.searchedWord};
        this.$store.dispatch("Brand/searchBrand", {form: searchWord, page: 1});
      }
    },
  },
};
</script>
<style scoped>
.overflow_div {
  width: auto;
  height: 300px !important;
  overflow-y: auto;
}
</style>